import {NgModule} from '@angular/core';
import {SharedModule} from '../shared/shared.module';
import {NavbarComponent} from './navbar/navbar.component';
import {FooterComponent} from './footer/footer.component';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {InputFieldComponent} from './form-input/input-field/input-field.component';
import {PartnerInformationFormComponent} from './create-proposal/partner-information-form/partner-information-form.component';
import {RiskDataFormComponent} from './create-proposal/risk-data-form/risk-data-form.component';
import {AmountInsuredFormComponent} from './create-proposal/amount-insured-form/amount-insured-form.component';
import {RiskDescriptionFormComponent} from './create-proposal/risk-description-form/risk-description-form.component';
import {UploadComponent} from './upload-field/upload.component';
import {DndDirective} from '../directive/dnd.directive';
import {RiskLocationFormComponent} from './create-proposal/risk-location-form/risk-location-form.component';
import {InternationalProgramFormComponent} from './create-proposal/international-program-form/international-program-form.component';
import {PreviousDamageFormComponent} from './create-proposal/previous-damage-form/previous-damage-form.component';
import {ProposalInformationFormComponent} from './create-proposal/proposal-information-form/proposal-information-form.component';

import {ValidatorsModule} from '../validator/validators.module';
import {UserInfoComponent} from './user-info/user-info.component';
import {NumberFormatDirective} from '../directive/number-format.directive';
import {
  CreateOfferContainerComponent
} from './proposal-details-components/create-offer-tab/create-offer-container/create-offer-container.component';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatIconModule} from '@angular/material/icon';

import {ProposalPreview} from './proposal-preview/proposal-preview.component';
import {
  InsuranceContractDetailPartnerInfoComponent
} from './insurance-contract-details-elements/insurance-contract-detail-partner-info/insurance-contract-detail-partner-info.component';
import {
  InsuranceContractDetailRiskInfoComponent
} from './insurance-contract-details-elements/insurance-contract-detail-risk-info/insurance-contract-detail-risk-info.component';
import {
  InsuranceContractDetailSumInsuredsComponent
} from './insurance-contract-details-elements/insurance-contract-detail-sum-insureds/insurance-contract-detail-sum-insureds.component';
import {
  InsuranceContractDetailRiskDescriptionComponent
} from './insurance-contract-details-elements/insurance-contract-detail-risk-description/insurance-contract-detail-risk-description.component';
import {
  InsuranceContractDetailPreviousDamagesComponent
} from './insurance-contract-details-elements/insurance-contract-detail-previous-damages/insurance-contract-detail-previous-damages.component';
import {
  InsuranceContractDetailAdvertisementInfoComponent
} from './insurance-contract-details-elements/insurance-contract-detail-advertisment-info/insurance-contract-detail-advertisement-info.component';
import {OfferOverviewComponent} from './offer-overview/offer-overview.component';
import {DialogConfirmComponent} from './dialogs/dialog-confirm/dialog-confirm.component';
import {TextFieldModule} from '@angular/cdk/text-field';
import {DialogTwoOptionsComponent} from './dialogs/two-options-dialog/dialog-two-options.component';
import {A11yModule} from '@angular/cdk/a11y';

import {ContactInformationFormComponent,} from './create-user/contact-information-form/contact-information-form.component';
import {PersonalInformationFormComponent} from './create-user/personal-information-form/personal-information-form.component';
import {YourDataComponent} from './proposal-details-components/create-offer-tab/create-offer-elements/your-data/your-data.component';
import {
  PremiumInformationFormComponent
} from './proposal-details-components/create-offer-tab/create-offer-elements/premium-information-form/premium-information-form.component';
import {
  IndividualInformationFormComponent
} from './proposal-details-components/create-offer-tab/create-offer-elements/individual-information-form/individual-information-form.component';
import {
  CoverageInformationComponent
} from './proposal-details-components/create-offer-tab/create-offer-elements/coverage-information/coverage-information.component';
import {OffersListTabComponent} from './proposal-details-components/offers-list-tab/offers-list-tab.component';
import {HvbHeaderComponent} from './static-page-components/page-header/hvb-header.component';
import {HvbFooterComponent} from './static-page-components/page-footer/hvb-footer.component';
import {
  ContactInformationCompanyFormComponent
} from './create-company/contact-information-company-form/contact-information-company-form.component';
import {AddressInformationCompanyFormComponent} from './create-company/address-information-form/address-information-company-form.component';
import {ProposalFilterComponent} from './proposal-filter/proposal-filter.component';
import {OffersDetailsTabComponent} from './proposal-details-components/offers-list-tab/offers-details-tab/offers-details-tab.component';
import {ShowTextDialog} from './dialogs/show-text-dialog/show-text-dialog.component';
import {ProposalSlipTabComponent} from './proposal-details-components/proposal-slip-tab/proposal-slip-tab.component';
import {ProposalSlipComponent} from './proposal-details-components/proposal-slip-tab/proposal-slip/proposal-slip.component';
import {ProposalDetailsExpandableComponent} from './proposal-details-components/proposal-details-tab/proposal-details-expandable.component';
import {ProposalVersionHistoryComponent} from './proposal-details-components/version-history-tab/proposal-version-history.component';
import {ProposalVersionDetailsExpandableComponent} from './proposal-details-components/version-history-tab/proposal-version-details-expandable.component';
import {VersionHistoryFilesComponent} from './proposal-details-components/version-history-tab/version-history-files.component';
import {ProposalTileComponent} from './proposal-tile/proposal-tile.component';
import {ProfileUserEditComponent} from './profile-user-edit/profile-user-edit.component';
import {ExternalCoverageComponent} from './proposal-details-components/offers-list-tab/external-coverage/external-coverage.component';
import {
  ExternalInsurerFormComponent
} from './proposal-details-components/offers-list-tab/external-coverage/external-insurer-form/external-insurer-form.component';
import {
  OfferFileUploadComponent
} from './proposal-details-components/create-offer-tab/create-offer-elements/offer-file-upload/offer-file-upload.component';
import {CompanyProfileEditComponent} from './company-profile-edit/company-profile-edit.component';
import {
  ProposalDetailInternationalProgramComponent
} from './insurance-contract-details-elements/proposal-detail-international-program/proposal-detail-international-program.component';
import {YourDataCreateProposalComponent} from './create-proposal/your-data-create-proposal/your-data-create-proposal.component';
import {ProposalUploadSummaryComponent} from './create-proposal/proposal-upload-summary/proposal-upload-summary.component';
import {UploadContainerComponent} from './upload-container/upload-container.component';
import {PrivacyPolicyComponent} from './create-user/privacy-policy/privacy-policy.component';
import {
  CreateOfferInformationComponent
} from './proposal-details-components/create-offer-tab/create-offer-information/create-offer-information.component';
import {OfferVersionHistoryDialogComponent} from './proposal-details-components/offers-list-tab/offer-version-history/offer-version-history-dialog.component';
import {OfferVersionDetailsExpandableComponent} from './proposal-details-components/offers-list-tab/offer-version-history/offer-version-details-expandable.component';
import {DownloadFilesComponent} from './download-files/download-files.component';
import {
  ProposalDetailsDownloadComponent
} from './insurance-contract-details-elements/proposal-details-download/proposal-details-download.component';
import {
  OfferStatusChangeModalComponent
} from './proposal-details-components/offers-list-tab/offer-status-change-modal/offer-status-change-modal.component';
import {NgxMatSelectSearchModule} from 'ngx-mat-select-search';
import { CustomSnackbarComponent } from './snackbar/custom-snackbar/custom-snackbar.component';
import { SpinnerDialogComponent } from './dialogs/spinner-dialog/spinner-dialog.component';
import { ContactSupportHelpComponent} from './help/contact-support-help/contact-support-help.component';
import { VideosHelpComponent} from './help/videos-help/videos-help.component';
import { ReleaseNotesHelpComponent} from './help/release-notes-help/release-notes-help.component';
import { FAQHelpComponent} from './help/faq-help/faq-help.component';
import { InfoIconComponent } from './dialogs/info-icon/info-icon.component';
import { AnnouncementsDialogComponent } from './dialogs/announcements-dialog/announcements-dialog.component';
import {DragDropModule} from '@angular/cdk/drag-drop';
import { SmallDeviceDialogComponent } from './dialogs/small-device-dialog/small-device-dialog.component';
import { PrivateNotesDialogComponent } from './dialogs/private-notes-dialog/private-notes-dialog.component';
import { InsuranceContractDetailRiskLocationsComponent } from './insurance-contract-details-elements/insurance-contract-detail-risk-locations/insurance-contract-detail-risk-locations.component';
import { LobModalComponent } from './dialogs/lob-modal/lob-modal.component';
import {MarkdownModule} from 'ngx-markdown';
import {NgScrollbarModule} from 'ngx-scrollbar';
import {MatOption, MatSelect, MatSelectModule} from '@angular/material/select';
import {MatDialogModule} from '@angular/material/dialog';
import {MatButtonModule} from '@angular/material/button';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatRadioModule} from '@angular/material/radio';
import {MatTableModule} from '@angular/material/table';
import {MatTabsModule} from '@angular/material/tabs';
import {MatCheckboxModule} from '@angular/material/checkbox';
import { NotificationPreferencesComponent } from './notification-preferences/notification-preferences.component';
import {MatGridListModule} from '@angular/material/grid-list';
import {LeadingOfferTabComponent} from './proposal-details-components/leading-offer-tab/leading-offer-tab.component';
import {SkendataRegistrationDialogComponent} from './dialogs/skendata-registration-dialog/skendata-registration-dialog.component';
import {OfferTileComponent} from './offer-tile/offer-tile.component';
import {RefillOfferConfirmDialogComponent} from './dialogs/refill-offer-confirm-dialog/refill-offer-confirm-dialog.component';
import {SharePDFDialogComponent} from './dialogs/share-proposal-pdf-dialog/share-proposal-pdf-dialog';
import {
  IndividualClausesConditionsFormComponent
} from './create-proposal/individual-clauses-conditions-form/individual-clauses-conditions-form.component';
import {
  InsuranceContractDetailIndividualClausesConditionsComponent
} from './insurance-contract-details-elements/insurance-contract-detail-individual-clauses-conditions/insurance-contract-detail-individual-clauses-conditions.component';

@NgModule({
  declarations: [
    FooterComponent,
    NavbarComponent,
    ProposalTileComponent,
    UserInfoComponent,
    DndDirective,
    NumberFormatDirective,
    InputFieldComponent,
    PartnerInformationFormComponent,
    RiskDataFormComponent,
    AmountInsuredFormComponent,
    RiskDescriptionFormComponent,
    IndividualClausesConditionsFormComponent,
    UploadComponent,
    RiskLocationFormComponent,
    InternationalProgramFormComponent,
    PreviousDamageFormComponent,
    ProposalInformationFormComponent,
    CreateOfferContainerComponent,
    ProposalPreview,
    InsuranceContractDetailPartnerInfoComponent,
    InsuranceContractDetailRiskInfoComponent,
    InsuranceContractDetailSumInsuredsComponent,
    InsuranceContractDetailRiskDescriptionComponent,
    InsuranceContractDetailIndividualClausesConditionsComponent,
    InsuranceContractDetailPreviousDamagesComponent,
    InsuranceContractDetailAdvertisementInfoComponent,
    ProposalDetailsExpandableComponent,
    ProposalVersionHistoryComponent,
    ProposalVersionDetailsExpandableComponent,
    VersionHistoryFilesComponent,
    OfferVersionHistoryDialogComponent,
    OfferVersionDetailsExpandableComponent,
    OfferOverviewComponent,
    OfferTileComponent,
    DialogConfirmComponent,
    DialogTwoOptionsComponent,
    SkendataRegistrationDialogComponent,
    RefillOfferConfirmDialogComponent,
    PersonalInformationFormComponent,
    ContactInformationFormComponent,
    ContactInformationCompanyFormComponent,
    AddressInformationCompanyFormComponent,
    YourDataComponent,
    PremiumInformationFormComponent,
    IndividualInformationFormComponent,
    CoverageInformationComponent,
    FooterComponent,
    HvbHeaderComponent,
    HvbFooterComponent,
    OffersListTabComponent,
    ProposalFilterComponent,
    OffersDetailsTabComponent,
    ProposalSlipTabComponent,
    ProposalSlipComponent,
    ShowTextDialog,
    ExternalCoverageComponent,
    ExternalInsurerFormComponent,
    ProfileUserEditComponent,
    ExternalInsurerFormComponent,
    OfferFileUploadComponent,
    CompanyProfileEditComponent,
    ProposalDetailInternationalProgramComponent,
    YourDataCreateProposalComponent,
    ProposalUploadSummaryComponent,
    UploadContainerComponent,
    PrivacyPolicyComponent,
    DownloadFilesComponent,
    ProposalDetailsDownloadComponent,
    CreateOfferInformationComponent,
    OfferStatusChangeModalComponent,
    CustomSnackbarComponent,
    SpinnerDialogComponent,
    ContactSupportHelpComponent,
    VideosHelpComponent,
    ReleaseNotesHelpComponent,
    FAQHelpComponent,
    InfoIconComponent,
    AnnouncementsDialogComponent,
    SmallDeviceDialogComponent,
    PrivateNotesDialogComponent,
    InsuranceContractDetailRiskLocationsComponent,
    LobModalComponent,
    NotificationPreferencesComponent,
    LeadingOfferTabComponent,
    SharePDFDialogComponent
  ],
  imports: [
    SharedModule,
    MatDialogModule,
    MatButtonModule,
    NgbModule,
    MatTooltipModule,
    MatSlideToggleModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    MatSelectModule,
    ValidatorsModule,
    MatRadioModule,
    MatExpansionModule,
    NgScrollbarModule,
    MatIconModule,
    MatTableModule,
    TextFieldModule,
    A11yModule,
    MatTabsModule,
    MatCheckboxModule,
    NgxMatSelectSearchModule,
    DragDropModule,
    MarkdownModule,
    MatSelect,
    MatOption,
    NgxMatSelectSearchModule,
    MatGridListModule,
  ],
    exports: [
        FooterComponent,
        UploadComponent,
        OfferFileUploadComponent,
        NavbarComponent,
        ProposalTileComponent,
        PartnerInformationFormComponent,
        RiskDataFormComponent,
        AmountInsuredFormComponent,
        RiskDescriptionFormComponent,
        IndividualClausesConditionsFormComponent,
        RiskLocationFormComponent,
        InternationalProgramFormComponent,
        PreviousDamageFormComponent,
        ProposalInformationFormComponent,
        CreateOfferContainerComponent,
        ProposalPreview,
        NumberFormatDirective,
        OfferOverviewComponent,
        OfferTileComponent,
        ProposalDetailsExpandableComponent,
        ProposalVersionHistoryComponent,
        ProposalVersionDetailsExpandableComponent,
        InputFieldComponent,
        ContactInformationFormComponent,
        PersonalInformationFormComponent,
        ContactInformationCompanyFormComponent,
        AddressInformationCompanyFormComponent,
        HvbHeaderComponent,
        HvbFooterComponent,
        ProposalFilterComponent,
        OffersListTabComponent,
        ProposalSlipTabComponent,
        ProfileUserEditComponent,
        CompanyProfileEditComponent,
        YourDataComponent,
        YourDataCreateProposalComponent,
        ProposalUploadSummaryComponent,
        PrivacyPolicyComponent,
        CreateOfferInformationComponent,
        ExternalCoverageComponent,
        ContactSupportHelpComponent,
        VideosHelpComponent,
        ReleaseNotesHelpComponent,
        FAQHelpComponent,
        LobModalComponent,
        UploadContainerComponent,
        ProposalDetailsDownloadComponent,
        DownloadFilesComponent,
        NotificationPreferencesComponent,
        LeadingOfferTabComponent,
        SharePDFDialogComponent
    ]
})

export class ComponentsModule {
}
